import React, {useState, useEffect, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { history } from '../../_helpers';

import {TableApp} from '../Table/Table'


function ApplyHistory(){
  const [state, actions] = useContext(UserContext);
  const [applylist, setApplylist] = useState([])
  const [recruit, setRecruit] = useState([])
  const [recruitHH, setRecruitHH] = useState([])
  // const [ra, setRa] = useState()
  // const [applicant, setApplicant] = useState()
  // const [viewers, setViewers] = useState()
  
  
  let user = JSON.parse(String(localStorage.getItem('user')))
  
  const header = {Authorization: `JWT ${user.token}`}
  
  let current_path = history.location.pathname.split('/')[1]

  useEffect(()=>{
    async function fetchApplylist(){
      fetch(state.awslink + "/api/apply/", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        if(json){
          console.log(json)
        }
        setApplylist(json)
        
        
      }
      )
    }
    fetchApplylist()
  }, [])  

  // console.log(applicant[0].email)
  // if(ralist === null){
  //   if(state.token != undefined)
  //     fetchRalist();
  // }

  console.log(applylist, recruit, recruitHH)
  
  return(
    <>
    {state.width < state.breakpoint ? 
      null
    :
      <Wrapper>
        <MidWrapper>
          <LeftWrapper>
            <div>
              <h4>
                {current_path === "applylist" ? "지원현황" : "제안현황"}
              </h4>
            </div>
          </LeftWrapper>
          <RightWrapper>
            {current_path === "applylist" ? 
              <Board>
                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="지원완료").length}
                    </div>
                    <p>지원완료</p>
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="추천").length}
                    </div>
                    <p>추천완료</p>
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="서류합격").length}
                    </div>
                    <p>서류합격</p>
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="최종합격").length}
                    </div>
                    <p>최종합격</p>
                  </div>
                </div>
              </Board>
              :
              <Board>

                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="제안보냄" || item.step==="추천제안").length}
                    </div>
                    <p>받은제안</p>
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="제안수락").length}
                    </div>
                    <p>제안수락</p>
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="검토").length}
                    </div>
                    <p>원해요</p>
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      {applylist.filter(item=>item.step==="임시").length}
                    </div>
                    <p>임시</p>
                  </div>
                </div>
              </Board>
            }

            <RaList>
              {applylist?
                applylist.map((item, index)=>{
                  let link_id 
                  let link_title
                  // console.log(item.recruit, item.recruitHH)
                  if(item.recruit) {link_id = item.recruit.id; link_title = item.recruit.title}
                  else if(item.recruitHH) {link_id = item.recruitHH.id; link_title = item.recruitHH.title}
                  
                  if(current_path === "applylist"){
                    // console.log("APPLYLIST")
                    if(item.step === "지원완료"
                      || item.step === "추천"
                      || item.step === "서류합격"
                      || item.step === "최종합격")
                      return(
                        <Card>
                          
                          {item.recruit || item.recruitHH?
                          <>
                            <Link to={'/ralist/single/'+ link_id + '/' + link_title}> </Link>
                            {item.recruit &&
                              <>
                                <div>{item.recruit.title}</div>
                                <div>{item.recruit.field}</div>
                                <div>{item.recruit.job}</div>
                              </>
                            }
                            {item.recruitHH &&
                              <>
                                <div>{item.recruitHH.title}</div>
                                <div>{item.recruitHH.field}</div>
                                <div>{item.recruitHH.category}</div>
                              </>
                            }
                            
                          </>
                          : null}
                          
                          <div>{item.step}</div>
                          <div>{item.created.split('T')[0]}</div>
                          <div>{item.updated.split('T')[0]}</div>
                        </Card>
                      )
                  }
                  else if(current_path === "proposallist"){
                    if(item.step === "제안보냄"
                      || item.step === "추천제안"
                      || item.step === "제안수락"
                      // || item.step === "추천"
                      // || item.step === "검토"
                    )
                      return(
                        <Card>
                          
                          {item.recruit || item.recruitHH?
                          <>
                            <Link to={'/ralist/single/'+ link_id + '/' + link_title}> </Link>
                            {item.recruit &&
                              <>
                                <div>{item.recruit.title}</div>
                                <div>{item.recruit.field}</div>
                                <div>{item.recruit.category}</div>
                              </>
                            }
                            {item.recruitHH &&
                              <>
                                <div>{item.recruitHH.title}</div>
                                <div>{item.recruitHH.field}</div>
                                <div>{item.recruitHH.category}</div>
                              </>
                            }
                          </>
                          : null}
                          
                          <div>{recruit[index]}</div>
                          <div>{item.step}</div>
                          <div>{item.created.split('T')[0]}</div>
                          <div>{item.updated.split('T')[0]}</div>
                        </Card>
                      )
                  }
                })
                
              : null}
            </RaList>
          </RightWrapper>
        </MidWrapper>
      </Wrapper>   
      }
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 45px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`
const MidWrapper = styled.div`
  display: flex;
  width: 90%;
  max-width: 1060px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: row;
`

const LeftWrapper = styled.div`
    display: flex;
    width: 29%;
    margin-right: 1%;
    min-height: 90%;
    position: relative;
    height: auto;
    margin-top: 20px;
    background-color: inherit;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;

    >div{
      position: relative;
      /* left: 5%; */
      width: 100%;
      height: auto;
      /* height: calc(90% - 45px); */

      box-sizing: border-box;
      padding: 20px;

      margin-bottom: 10px;

      @media only screen and (max-width: 1060px){
        /* left: 5%; */
        width: 100%;
      }
      
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align:left;

      border-radius: 5px;

      >h4{
        font-size: 1rem;
        margin: 0;
        margin-bottom: 10px;
      }
    }
`


const RightWrapper = styled.div`
    display: flex;
    width: 69%;
    margin-left: 1%;
    min-height: 90%;
    position: relative;
    top: 20px;
    height: auto;
    /* border: red solid; */
    background-color: inherit;

    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    /* box-sizing: border-box;
    padding: 20px;

    border-radius: 5px; */
    
    .devider{
      display: block;
      width: 100%;
      height: 1px;
      margin-bottom: 10px;
      border-top: 1px solid rgba(0,0,0,0.2);
    }
`


const Board = styled.div`
  background-color: white;
  
  display: flex;
  width: 100%;
  height: auto;
  margin: 0;
  flex-direction: row;
  
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 10px;

  border-radius: 5px;

  >div{
    display: flex;
    width: 100%;
    margin: 0;

    >div{
      display: flex;
      flex-direction: column;
      width: 100%;
      >div{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.8rem;
      }
      p{
        font-size: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
    }
    
  }

`

const RaList = styled.div`
  background-color: white;
  
  display: flex;
  width: 100%;
  height: auto;
  margin: 0;
  flex-direction: column;
  
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 10px;

  border-radius: 5px;
`

const Card = styled.div`
  /* width: 25%; */
  width: 100%;
  /* max-width: 240px; */
  height: 125px;
  border: rgba(0,0,0,0.5) 2px solid;
  border-radius: 7px;
  /* padding: 5px; */

  display: flex;
  /* flex-wrap: wrap; */
  /* flex-grow: 4; */
  justify-content: flex-start;
  
  align-items: flex-start;
  flex-direction: column;
  position: relative;

  >a{
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* z-index:2; */
  }
`

export default ApplyHistory